import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TabProvider } from './hooks'

export const TabContainer = ({defaultActiveKey, children}) => {
    const [activeKey, setActiveKey] = useState(defaultActiveKey)
    const provide = {
        activeKey,
        setActiveKey
    }
    return ( 
        <TabProvider value={provide}>
            {children}
        </TabProvider> 
    )
}

TabContainer.propTypes = {
    defaultActiveKey: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired
}
